export enum NotificationTypeEnum {
    // Brand
    NewMessage = 'New Message',
    InterestedInMyBrand = 'InterestedInMyBrand',
    VideoUploaded = 'Video Uploaded',
    Applied = 'Applied',
}

export interface CreateNotificationInAppDto {
    createdDate: Date;
    businessAccountId: string;
    businessUserId: string;
    type: NotificationInAppTypeEnum;
    title: string;
    content: string;
    image: string;
    route: string;
    read: boolean;
    ugcBriefId: string;
}

export interface NotificationInAppDto extends CreateNotificationInAppDto {
    id: string;
}

export enum NotificationInAppTypeEnum {
    contentUploaded = 1,
    contentPosted = 2,
    accountInvite = 3,
    product = 4,
    briefInteraction = 5,
    copiedToClipBoard = 6,
    newMessage = 7,
    // 8 (Invited) and 9 (shoutPlusTierCapacity) are API-side values not yet mirrored here.
    adLicenseAccepted = 10,
    adLicenseDeclined = 11,
    adLicenseExpired = 12,
}